<template>
<div class="container-fluid">
	<img v-if="!data_loaded" class="center-me" src="/images/loading-color.svg">

	<div v-else class="row">
	    <div class="col-12">
	    	<div class="d-flex align-items-center">
				<h1 class="flex-grow-1" data-test="pageTitle">All Clients</h1>
				<router-link
					v-if="perms.can_create_client"
					:to="{ name: 'clients.create' }"
					v-tooltip.bottom="'Add Client'"
					class="btn btn-sm btn-ghost-primary text-gray-500 leading-none"
					data-test="addClientButton">
					<i class="far fa-plus-circle text-xl"></i>
	        	</router-link>
			</div>
			<div class="card">
				<table v-if="clients" class="table table-hover clients-table">
					<thead>
						<th></th>
						<th>Name</th>
						<th>Contact</th>
						<th>City</th>
						<th>State</th>
						<th></th>
					</thead>

					<tr v-for="client in clients" data-test="clientItem">
						<td>
							<div class="rounded-circle circle-cropped avatar-md ml-2 bg-gray-100 text-center">
						    	<img v-if="client.logo_url" :src="client.logo_url" class="img-fluid">
						    	<i v-else class="fal fa-hospital text-gray-500"></i>
						    </div>
						</td>	
						<td>
							<router-link :to="{ name: 'clients.show', params: { id: client.id } }">{{ client.name }}</router-link>
							<i v-if="user.client_id === client.id" class="fas fa-check-circle text-primary ml-auto mr-0 pl-1" v-tooltip.bottom="'Current Client'"></i>
							<br>
							<span v-for="service_line in client.service_lines" class="badge bg-orange-100 text-orange-700 mr-1">{{ service_line.label }}</span>
						</td>
						<td>{{ client.contact_display_name }}</td>
						<td>{{ client.city }}</td>
						<td>{{ client.state }}</td>
						<td class="drop-down drop-down-show dropleft text-right">
                            <a href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-ellipsis-h text-xl"></i></a>
                            <div class="dropdown-menu py-0" aria-labelledby="physicianDropDown">
                                <router-link :to="{ name: 'clients.show', params: { id: client.id } }" class="dropdown-item">View Client</router-link>
                                <router-link v-if="client.can.update" :to="{ name: 'clients.edit', params: { id: client.id } }" class="dropdown-item" data-test="editClient">Edit Client</router-link>
                            </div>
                        </td>
					</tr>
				</table>
				<p v-else>No Clients found.</p>

			</div>
		</div>
	</div>
</div>
</template>

<script>
	import { mapState } from 'vuex';
	import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

        data() {
            return {
                clients: null,
                data_loaded: false,
            }
        },

        created() {
        },

        activated() {
        	this.fetchClients();   
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Clients', to: { name: 'clients.index' } },
            ]);   
        },

        methods: {
        	fetchClients() {
        		axios.get('/api/admin/clients')
	                .then(({data}) => {
	                    this.clients = data;
	                    this.data_loaded = true;
	        	});
        	},
        },

        computed: mapState(['perms', 'user'])
    }
</script>